import {STATE_PROP_NAME} from './health-volume-matrix-constants'

export const getHealthVolumeMatrixState = state => state[STATE_PROP_NAME]
